"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Message = _interopRequireDefault(require("@rsuite/icon-font/lib/application/Message"));

// Generated by script, don't edit it please.
var Message = (0, _createSvgIcon["default"])({
  as: _Message["default"],
  ariaLabel: 'message',
  category: 'application',
  displayName: 'Message'
});
var _default = Message;
exports["default"] = _default;
module.exports = exports.default;